import Vue from "vue";
import Router from "vue-router";

import $store from "../store";
import toLogin from "@libs/login";


Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/reg/:uid",
      name: "Reg",
      meta: {
        title: "注册",
        keepAlive: 0,
        footer: false
      },
      component: () => import("@views/user/Reg.vue")
    },
    {
      path: "/user/game4",
      name: "Game4",
      meta: {
        title: "大转盘",
        // keepAlive: false,
        auth: false,
        footer: false
      },
      component: () => import("@views/user/games/Game4.vue")
    },
    {
      path: "/user/game5",
      name: "Game5",
      meta: {
        title: "飞刀",
        keepAlive: false,
        auth: true,
        footer: false
      },
      component: () => import("@views/user/games/Game5.vue")
    },
    {
      path: "/user/game7",
      name: "game7",
      meta: {
        title: "消消乐",
        // keepAlive: false,
        // auth: true,
        footer: false
      },
      component: () => import("@views/user/games/Game7_xiaoxiaole.vue")
    },
    {
      path: "/user/game9",
      name: "game9",
      meta: {
        title: "齐天大圣孙悟空",
        // keepAlive: false,
        // auth: true,
        footer: false
      },
      component: () => import("@views/user/games/Game9_tyt.vue")
    },
    {
      path: "/user/game10",
      name: "game10",
      meta: {
        title: "是男人就下100层",
        // keepAlive: false,
        // auth: true,
        footer: false
      },
      component: () => import("@views/user/games/Game10_ddp.vue")
    },
    {
      path: "/user/game11",
      name: "game11",
      meta: {
        title: "飞刀",
        // keepAlive: false,
        // auth: true,
        footer: false
      },
      component: () => import("@views/user/games/Game11_fd.vue")
    },
    // ...module,
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "名品mall",
        keepAlive: 0,
        footer: false
      },
      component: () => import("@views/index.vue")
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  // if ($store.state.app.routerBack) {
  //   $store.state.app.routerBack = false;
  // } else {
  //   $store.state.app.routerList.push(form.fullPath);
  // }

  const { title, backgroundColor, footer, home, auth } = to.meta;
  // console.log(to.name, form.name);
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "crmeb商城";
  //判断是否显示底部导航
  footer ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;
